import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { DiscountFormField } from '../types';

const useValidation = () => {
  const { t } = useTranslation();

  const validationSchema = useMemo(() => {
    return yup.object({
      [DiscountFormField.Name]: yup
        .string()
        .required(t('studio.discountModal.form.nameInput.error.required')),
      [DiscountFormField.DiscountValue]: yup.string().when(DiscountFormField.AppliesToProduct, {
        is: (val: string) => val !== 'any_tier',
        // eslint-disable-next-line unicorn/no-thenable
        then: schema =>
          schema
            .notOneOf(['100'], t('studio.discountModal.form.discountValueInput.error.required'))
            .required(t('studio.discountModal.form.discountValueInput.error.required')),
        otherwise: schema =>
          schema.required(t('studio.discountModal.form.discountValueInput.error.required')),
      }),
      [DiscountFormField.Audience]: yup
        .string()
        .required(t('studio.discountModal.form.audienceInput.error.required')),
      [DiscountFormField.AppliesToProduct]: yup
        .string()
        .required(t('studio.discountModal.form.appliesToCategoryInput.error.required')),
      [DiscountFormField.StartTimestamp]: yup
        .number()
        .required(t('studio.discountModal.form.startTimestamp.error.required')),
      [DiscountFormField.EndTimestamp]: yup
        .number()
        .required(t('studio.discountModal.form.endTimestamp.error.required'))
        .when(DiscountFormField.StartTimestamp, (start, schema) =>
          start != null
            ? schema.test(
                'is-after-start',
                t('studio.discountModal.form.endTimestamp.error.endAfterStart'),
                end => typeof end === 'number' && end > start
              )
            : schema
        ),
    });
  }, [t]);

  return validationSchema;
};

export default useValidation;
